import { getCreditApplication, getCreditApplicationFilteredList } from './miles-credit-services';

export const getCreditApplicationId = async (quoteId: string): Promise<string | undefined> => {
  const creditApplicationResponse = await getCreditApplicationFilteredList({
    offerIds: quoteId,
  });

  if (creditApplicationResponse.totalCount) {
    if (creditApplicationResponse.totalCount > 1) {
      throw new Error('Multiple credit applications found for quote ID: ' + quoteId);
    }

    return creditApplicationResponse?.creditApplications?.[0]?.creditDecision?.solvencyCheck?.decisionIdentifier;
  }

  return undefined;
};

export const getCreditApplicationResponse = async (
  creditApplicationId: string
): Promise<CreditIntegration.Schemas.CreditApplicationResponse | undefined> => {
  if (!creditApplicationId) {
    return undefined;
  }
  const creditApplicationResponse = await getCreditApplication(creditApplicationId);
  return creditApplicationResponse;
};

export const getCustomerCreditScoreId = async (creditApplicationId: string): Promise<string | undefined> => {
  const creditApplicationResponse = await getCreditApplicationResponse(creditApplicationId);

  if (creditApplicationResponse && creditApplicationResponse.customerData?.externalIdentifiers) {
    const customerIdentifier = creditApplicationResponse.customerData?.externalIdentifiers?.find(
      (i) => i?.type === 'MILES_CUSTOMER_APPLICANT_CREDIT_ID'
    );

    return customerIdentifier?.id;
  }

  return undefined;
};

export const getCoCustomerCreditScoreId = async (creditApplicationId: string): Promise<string | undefined> => {
  const creditApplicationResponse = await getCreditApplicationResponse(creditApplicationId);

  if (
    creditApplicationResponse &&
    creditApplicationResponse.customerData?.customerRelations?.[0]?.externalIdentifiers
  ) {
    const customerIdentifier =
      creditApplicationResponse.customerData?.customerRelations?.[0]?.externalIdentifiers?.find(
        (i) => i?.type === 'MILES_CUSTOMER_APPLICANT_CREDIT_ID'
      );

    return customerIdentifier?.id;
  }

  return undefined;
};
